import colors from "vuetify/es5/util/colors";

const style = {
  primary: colors.orange
};

export default style;
